export const platformConfig = {
  'zhaixing': {
    favIcon: 'https://dev.cdn-pub.zxaigc.com/public/68cee801754c90d5dcc1.png',
    logo: 'https://dev.cdn-pub.zxaigc.com/public/7d5bff5d0927e5408dab.png',
    background: 'https://dev.cdn-pub.zxaigc.com/public/87d164069bd1325566de.png',
    favTitle: '摘星方舟',
    filing: '皖ICP备2024062962号-1',
  },
  'yunshi': {
    favIcon: 'https://zhaixing-prod-00.oss-cn-shanghai.aliyuncs.com/public/ccd127c08f3967fe90e53ba45103d74b%402x%20(1).png',
    logo: 'https://zhaixing-prod-00.oss-cn-shanghai.aliyuncs.com/public/4098f846ad523ea00cc4394140073e3.png',
    background: 'https://zhaixing-prod-00.oss-cn-shanghai.aliyuncs.com/public/95011.png',
    favTitle: '云视获客',
    filing: '皖ICP备2024062962号-1',
  },
  '51wl': {
    favIcon: 'https://ysai-00.oss-cn-shanghai.aliyuncs.com/public/tiepai/51wl/1.png',
    logo: 'https://ysai-00.oss-cn-shanghai.aliyuncs.com/public/tiepai/51wl/2.png',
    background: 'https://ysai-00.oss-cn-shanghai.aliyuncs.com/public/tiepai/51wl/3.png',
    favTitle: '搜索排名',
    filing: '皖ICP备18001927号-16',
  },
  'fengyin': {
    favIcon: 'https://ysai-00.oss-cn-shanghai.aliyuncs.com/public/tiepai/fengyin/1.png',
    logo: 'https://ysai-00.oss-cn-shanghai.aliyuncs.com/public/tiepai/fengyin/2.png',
    background: 'https://ysai-00.oss-cn-shanghai.aliyuncs.com/public/tiepai/fengyin/3.png',
    favTitle: '云视搜索',
    filing: '蜀ICP备2024055338号-1'
  },
  'juyuai': {
    favIcon: 'https://ysai-00.oss-cn-shanghai.aliyuncs.com/public/tiepai/juyuai/1.png',
    logo: 'https://ysai-00.oss-cn-shanghai.aliyuncs.com/public/tiepai/juyuai/2.png',
    background: 'https://ysai-00.oss-cn-shanghai.aliyuncs.com/public/tiepai/juyuai/3.png',
    favTitle: '巨宇AI获客',
    filing: '浙ICP备12013743号-16'
  },
  'qiteng518': {
    favIcon: 'https://ysai-00.oss-cn-shanghai.aliyuncs.com/public/tiepai/qiteng518/1.png',
    logo: 'https://ysai-00.oss-cn-shanghai.aliyuncs.com/public/tiepai/qiteng518/2.png',
    background: 'https://ysai-00.oss-cn-shanghai.aliyuncs.com/public/tiepai/qiteng518/3.png',
    favTitle: '剪辑系统',
    filing: '津ICP备2022003066号-6'
  },
  'tui55': {
    favIcon: 'https://ysai-00.oss-cn-shanghai.aliyuncs.com/public/tiepai/tui55/1.png',
    logo: 'https://ysai-00.oss-cn-shanghai.aliyuncs.com/public/tiepai/tui55/2.png',
    background: 'https://ysai-00.oss-cn-shanghai.aliyuncs.com/public/tiepai/tui55/3.png',
    favTitle: '千里马AI获客',
    filing: '渝ICP备13002463号-18'
  },
  'pbinfo': {
    favIcon: 'https://ysai-00.oss-cn-shanghai.aliyuncs.com/public/tiepai/pbinfo/1.png',
    logo: 'https://ysai-00.oss-cn-shanghai.aliyuncs.com/public/tiepai/pbinfo/2.png',
    background: 'https://ysai-00.oss-cn-shanghai.aliyuncs.com/public/tiepai/pbinfo/3.png',
    favTitle: '鹏博资讯',
    filing: '粤ICP备11039585号-5'
  },
  '15yuansu': {
    favIcon: 'https://15yuansu-00.oss-cn-shanghai.aliyuncs.com/public/logo.png',
    logo: 'https://15yuansu-00.oss-cn-shanghai.aliyuncs.com/public/%E5%BE%AE%E4%BF%A1%E5%9B%BE%E7%89%87_20251010165113.png',
    background: 'https://15yuansu-00.oss-cn-shanghai.aliyuncs.com/public/%E6%9C%AA%E6%A0%87%E9%A2%98-1.png',
    favTitle: '15元素',
    filing: '浙ICP备2024122376号-1'
  },
  'ai': {
    favIcon: 'https://prod.cdn-pub.zxaigc.com/public/aivideo.png',
    logo: 'https://prod.cdn-pub.zxaigc.com/public/factory-logo.png',
    background: 'https://prod.cdn-pub.zxaigc.com/public/login_banner.png',
    favTitle: 'Ai梦工厂',
    filing: '皖ICP备2024062962号-1',
    devUrl: {
      douyinRedirectUrl: 'https://dev.v-matrix.zxaigc.com/matrix/douyinAuth',
      kuaishouRedirectUrl: 'https://dev.v-matrix.zxaigc.com/matrix/authcallback',
      bilibiliRedirectUrl: 'https://dev.v-matrix.zxaigc.com/matrix/bilibili-callback'
    },
    proUrl: {
      douyinRedirectUrl: 'https://v-matrix.zxaigc.com/matrix/douyinAuth',
      kuaishouRedirectUrl: 'https://v-matrix.zxaigc.com/matrix/authcallback',
      bilibiliRedirectUrl: 'https://v-matrix.zxaigc.com/matrix/bilibili-callback'
    }
  },
}